import { FC, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import JitsiConference from '../components/JitsiConference';
import Jitsi from '../services/Jitsi';
import Constants from '../../constants/constants';

const RemoteTherapySession: FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { user } = useSelector((state: any) => state);
  const { id } = useParams<{ id: string }>();
  const [jaasToken, setJaasToken] = useState<string | null>(null);
  const [roomName, setRoomName] = useState<string | null>(null);
  const username = [user.currentUserFirstName, user.currentUserLastName].join(' ');
  useEffect(() => {
    if (user.roleLevel === Constants.PLAYER_ROLE_LEVEL) {
      Jitsi.getJwtToken().then((data) => {
        setJaasToken(data.token);
        setRoomName(data.room);
      });
    } else {
      Jitsi.getJwtToken(parseInt(id)).then((data) => {
        setJaasToken(data.token);
        setRoomName(data.room);
      });
    }
  }, []);

  const playerIdExpectedAndPresent =
    user.roleLevel === Constants.PLAYER_ROLE_LEVEL || (user.roleLevel !== Constants.PLAYER_ROLE_LEVEL && id);

  if (!playerIdExpectedAndPresent || !jaasToken || !roomName) {
    return <div>Loading...</div>;
  }

  return <JitsiConference room={roomName} token={jaasToken} name={username} />;
};

export default RemoteTherapySession;
